<script setup>
import BaseMenu from '@/components/base/BaseMenu.vue'

import { computed, defineProps, defineEmits } from 'vue'
import { useStore } from '@/utils/VuexHelpers'
import { INVOICE_STATUS, isInvoicedStatus } from '@/constants/invoiceStatus'

const emit = defineEmits(['update-invoice-status', 'update-customer'])
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  invoiceStatus: {
    type: String,
    default: INVOICE_STATUS.DRAFT
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const store = useStore()

const isLocked = computed(() => {
  return isInvoicedStatus(props.invoiceStatus)
})

const items = computed(() => [
  {
    key: 'recalculate-pricing',
    title: isLocked.value ? 'Pricing Locked' : 'Recalculate Pricing',
    icon: isLocked.value ? 'mdi-lock-outline' : 'mdi-sync',
    action: () => handleRecalculatePricing(props.item),
    disabled: isLocked.value
  },
  {
    key: 'update-invoice-status',
    title: isLocked.value ? 'Reopen / Update Status' : 'Update Invoice Status',
    icon: 'mdi-list-status',
    action: () => {
      emit('update-invoice-status')
    },
    disabled: false
  },
  {
    key: 'update-customer',
    title: 'Update Customer',
    icon: 'mdi-account-edit-outline',
    action: () => {
      emit('update-customer')
    },
    disabled: isLocked.value
  }
])

const handleRecalculatePricing = async (item) => {
  const payload = {
    id_list: String(item.id)
  }

  const res = await store.dispatch('updateRevenuePrices', { payload })

  if (res !== 'error') {
    store.dispatch('fetchRevenue')
  }
}
</script>

<template>
  <BaseMenu :items="items">
    <template #item-recalculate-pricing="{ item: menuItem }">
      <v-list-item
        class="bsp-list-item"
        :disabled="menuItem.disabled || loading"
        @click="!menuItem.disabled && menuItem.action()"
      >
        <v-list-item-icon>
          <v-icon dense>
            {{ menuItem.icon }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="text-body-1 text-start">
            {{ menuItem.title }}
          </v-list-item-title>

          <v-list-item-subtitle v-if="isLocked" class="text-start">
            Invoice has been exported
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </BaseMenu>
</template>
